import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import { API } from 'lib-core'
import { loadRequest } from 'state/actions/crud_actions'
const component = universal(props => import('./HomeNewsTagCirclesPage'))

class AsyncHomeNewsTagCirclesPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, { api }: { api: API, req }) {
    const {
      session: { value: profile } = {},
      location: { payload: { tag } }
    } = getState()

    if (!profile) {
      return
    }
    await loadRequest("discover", dispatch, () => {
      return api.makeRequest({
        path: `groups/tagged/${tag}/1-100`,
      })
    })
  }

}


export default new AsyncHomeNewsTagCirclesPage()
